import { Box, Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

import { InfoDisclaimerBox } from "@covertree/ui/content";
import { AdditionalInterestCard } from "@covertree/features";

import { InsuredTabAdditionalInterest } from "@redux/slices/endorsement";
import { EndorsementRoutes, getEndorsementPath } from "@routing/paths";
import { SALES_EMAIL_ADDRESS } from "@covertree/consts";

interface Props {
  readonly additionalInterest: InsuredTabAdditionalInterest;
  readonly policyLocator: string;
}

/** Billing additional interest (the mortgagee) on the endorsement checkout — read-only, with a link to update billing details. */
export function MortgageBillItem({ additionalInterest, policyLocator }: Props) {
  return (
    <>
      <Box mt={3} data-testid="endorsement-billing-additional-interest">
        <AdditionalInterestCard
          isEndorsementCheckout
          additionalInterest={additionalInterest}
        />
      </Box>

      <InfoDisclaimerBox mt={3}>
        To update billing details, go to the{" "}
        <Link
          color="secondary"
          component={RouterLink}
          to={getEndorsementPath(policyLocator, EndorsementRoutes.INSURED_INFO)}
          data-testid="endorsement-insured-info-link">
          Insured Info tab
        </Link>
        . To switch to CC/ACH or for any other issues, contact{" "}
        <Link color="secondary" href={`mailto:${SALES_EMAIL_ADDRESS}`}>
          {SALES_EMAIL_ADDRESS}
        </Link>
        .
      </InfoDisclaimerBox>
    </>
  );
}
